import '../estilo/evento.scss'
import * as comun from './modulos/comun'
import * as buscador from './widgets/buscador'
import { autorizacion } from './modulos/usuario'
import articulus from './modulos/articulus'
import { getFechaMesLargo, getFechaMesCortoComaAnio } from './modulos/utiles'
import { iniciarLibros } from './modulos/libros'

comun.registrarServiceWorker().catch(error => { console.error(error) })
comun.chorrear(() => {
  comun.iniciarMenu('mnuEventos')
})
buscador.iniciar()

// Obtiene de la URL nombre base del artículo
const partes = document.location.pathname.split('/')
if (partes[partes.length - 1] === '') { // Si la URL temina en barra el último elemento del array estará vacío
  partes.pop() // entonces se elimina
}
const artiBase = partes[partes.length - 1]
//

autorizacion().then(usr => {
  if (usr.esAdmin === 1) {
    document.getElementById('editArti').href = `/wm/secciones/articulo/eventos/${artiBase}`
    document.getElementById('editArti').classList.remove('oculto')
  }
}).catch(error => {
  if (error.message !== 'Usuario no autorizado') {
    console.error(error) 
  }
})
//

let url = `${comun.urlBaseApi}/apis/articulus/v1/blogs/eventos/articulos/${artiBase}`

articulus(url, 'es').then(arti => {
  mostrarArticulo(arti)
}).catch(error => {
  if (error === 'El artículo no existe.') {
    fetch('/404.html', { method: 'get' })
    .then(res => res.text())
    .then(resTexto => {
      document.getElementById('contenidos').innerHTML = resTexto
    }).catch(error => { console.error(error) })
  } else {
    console.error(error)
  }
})

function mostrarArticulo (arti) {
  document.title = arti.titulo
  document.querySelector('h1 > span.titulo').textContent = arti.titulo
  // Agrega propiedades src srcset y alt a imagen principal
  document.querySelector('.imgPrincipal').src = arti.imgPrincipal
  document.querySelector('.imgPrincipal').srcset = comun.obtenerSrcset(arti.imgPrincipal)
  document.querySelector('.imgPrincipal').alt = arti.titulo
  document.querySelector('.cuerpo').innerHTML = arti.texto
  //
  try {
    // Cambia comillas dobles por simples dentro de enlaces. Convierte <a href="#"> en <a href='#'>
    const enlaces = arti.entradilla.matchAll(/<a\s[^<]*>/g) // Busca enlaces
    let enlaceNuevo
    for (const enlace of enlaces) {
      enlaceNuevo = enlace[0].replace(/\"/g, "'") // Cambia comillas
      arti.entradilla = arti.entradilla.replace(enlace[0], enlaceNuevo) // Reemplaza enlace en el contenido
    }
    //
    let datosEnIntro = JSON.parse(arti.entradilla)
    document.querySelector('.descripcion').innerHTML = datosEnIntro.descripcion
    if (datosEnIntro.btnExtraTxt) {
      document.querySelector('.boton.extra .texto').textContent = typeof datosEnIntro.btnExtraTxt !== 'undefined' ? datosEnIntro.btnExtraTxt : ''
      document.querySelector('.boton.extra img').src = typeof datosEnIntro.btnExtraIco !== 'undefined' ? datosEnIntro.btnExtraIco : ''
      document.querySelector('.boton.extra').href = typeof datosEnIntro.btnExtraUrl !== 'undefined' ? datosEnIntro.btnExtraUrl : ''
      document.querySelector('.boton.extra').classList.remove('oculto')
    }
    mostrarTweets(datosEnIntro.tweets) // IDs de tweets separados por comas como argumento
  } catch (e) {
    document.querySelector('.descripcion').innerHTML = ''
  }
}

// Funciones aka presentaciones

url = `${comun.urlBaseApi}/apis/articulus/v1/blogs/eventos/articulos/${artiBase}/presentaciones`
articulus(url, 'es')
  .then(presentaciones => {
    let clonProxFuncion, clonFuncionAnte, oFecha, aAmd, aHms
    let mostrarTitProximas = false
    let oAhora = new Date()
    presentaciones.forEach(presenta => {
      // Separar fechas próximas y anteriores y mostrar
      aAmd = presenta.fechaHora.substr(0, 10).split("-") // Año mes día
      aHms = presenta.fechaHora.substr(11).split(":") // Hora minutos segundos
      oFecha = new Date(aAmd[0], (parseInt(aAmd[1], 10) - 1), aAmd[2], aHms[0], aHms[1], aHms[2]);
      if (oFecha.getTime() >= oAhora.getTime()) {
        clonProxFuncion = document.querySelector('.prox-funcion.plantilla').cloneNode(true)
        clonProxFuncion.querySelector('.fecha').textContent = getFechaMesLargo(`${aAmd[0]}-${aAmd[1]}-${aAmd[2]}`, 'es')
        clonProxFuncion.querySelector('.sala').textContent = presenta.sala
        clonProxFuncion.querySelector('.ciudad').textContent = presenta.ciudad
        clonProxFuncion.href = presenta.linkTickets
        if (presenta.modo === 'presencial') {
          if (presenta.vendido) {
            clonProxFuncion.querySelector('.triste').classList.remove('oculto')
            clonProxFuncion.classList.remove('color-uno')
            clonProxFuncion.classList.add('color-gris')
            clonProxFuncion.querySelector('.ciudad').innerHTML += ' (AGOTADO)'
          } else {
            clonProxFuncion.querySelector('.presencial').classList.remove('oculto')
          }
        } else if (presenta.modo === 'streaming') {
          clonProxFuncion.querySelector('.streaming').classList.remove('oculto')
          clonProxFuncion.classList.remove('color-uno')
          clonProxFuncion.classList.add('color-dos')
        }
        document.getElementById('proximasFunciones').insertBefore(clonProxFuncion, document.getElementById('proximasFunciones').firstChild)
        clonProxFuncion.classList.remove('plantilla')
        mostrarTitProximas = true
      } else {
        clonFuncionAnte = document.querySelector('.funcion-ante.plantilla').cloneNode(true)
        clonFuncionAnte.querySelector('.fecha').textContent = getFechaMesCortoComaAnio(`${aAmd[0]}-${aAmd[1]}-${aAmd[2]}`, 'es')
        clonFuncionAnte.querySelector('.sala').textContent = presenta.sala
        clonFuncionAnte.querySelector('.ciudad').textContent = presenta.ciudad
        document.getElementById('funcionesAnteriores').appendChild(clonFuncionAnte)
        clonFuncionAnte.classList.remove('plantilla')
      }
    })
    if (mostrarTitProximas) document.getElementById('titProxFunciones').classList.remove('oculto')
  }).catch(error => { console.error(error) })

// Twitter
window.twttr = (function(d, s, id) {
  var js, fjs = d.getElementsByTagName(s)[0],
    t = window.twttr || {}
  if (d.getElementById(id)) return t
  js = d.createElement(s)
  js.id = id
  js.src = "https://platform.twitter.com/widgets.js"
  fjs.parentNode.insertBefore(js, fjs)

  t._e = []
  t.ready = function(f) {
    t._e.push(f)
  }

  return t
}(document, "script", "twitter-wjs"))

function mostrarTweets (tweetIds) {
  tweetIds = tweetIds.split(',') // Crea array de IDs en la misma variable
  let cadenaPromesas = Promise.resolve()
  let tweet
  twttr.ready(twttr => {
    tweetIds.forEach(tweetId => {
      tweet = document.createElement('div') // Contenedor para el tweet
      tweet.id = tweetId
      document.getElementById('tweets').appendChild(tweet)
      // Agrega promesa de crear tweet
      cadenaPromesas = cadenaPromesas.then(() => {
        return twttr.widgets.createTweet(tweetId, document.getElementById(tweetId)) // Promesa de crear tweet
      })
    })
  })
  cadenaPromesas.then(() => {
    // Tweets creados
  }).catch(error => { console.error(error) })
}

//
iniciarLibros()
